import { useState } from 'react';

export default function FinalCTA() {
  const [hoveredButton, setHoveredButton] = useState<string | null>(null);

  return (
    <section className="relative bg-[#1A1C1E] py-32 overflow-hidden">
      {/* Gradient glow background */}
      <div className="absolute inset-0">
        <div 
          className="absolute inset-0 opacity-20"
          style={{
            background: 'radial-gradient(ellipse at center, rgba(0, 229, 255, 0.3) 0%, rgba(26, 28, 30, 0) 70%)'
          }}
        ></div>
      </div>

      {/* Animated gradient lines */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div 
          className="absolute top-1/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#00E5FF]/40 to-transparent animate-pulse"
        ></div>
        <div 
          className="absolute top-2/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#00E5FF]/40 to-transparent animate-pulse"
          style={{ animationDelay: '1s' }}
        ></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        {/* Headline */}
        <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-[#F4F7F6] mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Build Your Business on Intelligent Architecture
        </h2>

        {/* Supporting text */}
        <div className="space-y-6 mb-12">
          <p className="text-xl text-[#7F8C8D] leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            If your team spends hours every week on repetitive operational tasks, your systems are working against you.
          </p>
          
          <p className="text-xl text-[#7F8C8D] leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Graystone AI builds automation infrastructure that restores clarity, efficiency, and control.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <button
            onMouseEnter={() => setHoveredButton('primary')}
            onMouseLeave={() => setHoveredButton(null)}
            className="relative px-10 py-5 bg-[#00E5FF] text-[#1A1C1E] font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-lg"
            style={{
              fontFamily: 'Inter, sans-serif',
              boxShadow: hoveredButton === 'primary' ? '0 0 40px rgba(0, 229, 255, 0.7)' : '0 0 20px rgba(0, 229, 255, 0.4)',
              transform: hoveredButton === 'primary' ? 'translateY(-2px)' : 'translateY(0)'
            }}
          >
            Schedule a Systems Consultation
          </button>
          
          <button
            onMouseEnter={() => setHoveredButton('secondary')}
            onMouseLeave={() => setHoveredButton(null)}
            className="relative px-10 py-5 bg-transparent border-2 border-[#00E5FF] text-[#00E5FF] font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-lg"
            style={{
              fontFamily: 'Inter, sans-serif',
              boxShadow: hoveredButton === 'secondary' ? '0 0 30px rgba(0, 229, 255, 0.5)' : 'none',
              transform: hoveredButton === 'secondary' ? 'translateY(-2px)' : 'translateY(0)'
            }}
          >
            View Automation Examples
          </button>
        </div>

        {/* Footer line */}
        <div className="pt-8 border-t border-[#7F8C8D]/20 inline-block">
          <p className="text-sm text-[#7F8C8D] italic" style={{ fontFamily: 'Inter, sans-serif' }}>
            Orchestrated by Graystone AI.
          </p>
        </div>
      </div>
    </section>
  );
}